// extracted by mini-css-extract-plugin
export default {"notificationItem":"styles_notification-item_WXlmv","link":"styles_link_f7fnl"};